import React, { useEffect } from "react";
import LandingHeader from "../../components/landing/LandingHeader";
import HeroSection from "../../components/landing/HeroSection";
import ServicesSection from "../../components/landing/ServicesSection";
import AppDownloadSection from "../../components/landing/AppDownloadSection";
import LandingFooter from "../../components/landing/LandingFooter";

import "./Home.css";

const Home = () => {
  useEffect(() => {
    document.title = "Boost Zone — Relive · Recover · Perform";
    document.body.classList.add("hl-body");
    return () => document.body.classList.remove("hl-body");
  }, []);

  return (
    <div className="hl-page">
      <div className="hl-top-band">
        <LandingHeader />
        <HeroSection />
        <ServicesSection />
      </div>
      <AppDownloadSection />
      <LandingFooter />
    </div>
  );
};

export default Home;
